export default "__VITE_ASSET__e5f7325a__"